/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { classNames } from '../utils/UNSAFE_classNames';
import { multiVariantStyles, styles } from './themes/SeparatorStyles.css';

// TODO -  Expose props once vertical orientation is supported
type SeparatorProps = {
  /**
   * Separator's orientation.
   */
  orientation?: 'horizontal' | 'vertical';
};

// TODO - Support vertical orientation
export function Separator({ orientation = 'horizontal' }: SeparatorProps) {
  const variantClasses = multiVariantStyles({
    orientation: orientation
  });
  const classes = classNames([variantClasses, styles.separatorBase]);
  const separatorVerticalWrapperClass = classNames([
    orientation === 'vertical' && styles.separatorVerticalWrapper
  ]);
  // TODO - Check  with archs if this should be a polymorphic component and if the answer is yes, implement it
  return (
    <div role="separator" aria-orientation={orientation} class={separatorVerticalWrapperClass}>
      <div class={classes} />
    </div>
  );
}
